"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormCustomField = void 0;
const react_1 = __importStar(require("react"));
const form_field_wraper_1 = require("./wrapper/form-field-wraper");
const form_context_1 = require("../form-context");
function FormCustomField({ name, label, disabled = false, required = false, labelOptions = {}, layoutOptions = {}, errorOptions = {}, children, }) {
    const { errors } = react_1.useContext(form_context_1.FormContext);
    const fieldErrors = errors.filter((e) => e.key === name);
    return (react_1.default.createElement(form_field_wraper_1.FormFieldWrapper, { label: label, required: required, disabled: disabled, labelOptions: labelOptions, layoutOptions: layoutOptions, errorOptions: errorOptions, errors: fieldErrors }, children));
}
exports.FormCustomField = FormCustomField;
//# sourceMappingURL=form-custom-field.js.map